import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=e80c3bc4&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"
import style0 from "./formItem.vue?vue&type=style&index=0&id=e80c3bc4&prod&lang=scss&scoped=true"
import style1 from "./formItem.vue?vue&type=style&index=1&id=e80c3bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c3bc4",
  null
  
)

export default component.exports